// context/SchemaContext.js
import { createContext, useContext } from "react";

export const SchemaContext = createContext(null);

export function useSchema() {
  const ctx = useContext(SchemaContext);
  if (!ctx) throw new Error("useSchema must be used inside SchemaContext.Provider");
  return ctx;
}
